"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInternalAttributes = void 0;
const attributeOptions_js_1 = require("../../../attributes/constants/attributeOptions.js");
const index_js_1 = require("../../../attributes/string/index.js");
const get_js_1 = require("../../../entity/actions/update/symbols/get.js");
const index_js_2 = require("../../../errors/index.js");
const utils_js_1 = require("./utils.js");
const addInternalAttributes = ({ schema, table, entityAttributeName, entityAttributeHidden, entityName, timestamps }) => {
    const internalAttributes = {};
    const entityAttribute = (0, index_js_1.string)({
        required: 'atLeastOnce',
        defaults: {
            key: undefined,
            put: entityName,
            update: () => (0, get_js_1.$get)(entityAttributeName, entityName)
        }
    })
        /**
         * @debt type "when provided in options, 'hidden' is not correctly inferred"
         */
        .hidden(entityAttributeHidden)
        .enum(entityName)
        /**
         * @debt type "when provided in options, savedAs is inferred as potentially undefined"
         */
        .savedAs(table.entityAttributeSavedAs);
    internalAttributes[entityAttributeName] = entityAttribute;
    if ((0, utils_js_1.isTimestampEnabled)(timestamps, 'created')) {
        const createdName = (0, utils_js_1.getTimestampOptionValue)(timestamps, 'created', 'name');
        const createdAttribute = (0, index_js_1.string)({
            required: 'atLeastOnce',
            defaults: {
                key: undefined,
                put: () => new Date().toISOString(),
                update: () => (0, get_js_1.$get)(createdName, new Date().toISOString())
            }
        })
            /**
             * @debt type "when provided in options, 'hidden' is not correctly inferred"
             */
            .hidden((0, utils_js_1.getTimestampOptionValue)(timestamps, 'created', 'hidden'))
            /**
             * @debt type "when provided in options, 'savedAs' is inferred as potentially undefined"
             */
            .savedAs((0, utils_js_1.getTimestampOptionValue)(timestamps, 'created', 'savedAs'));
        internalAttributes[createdName] = createdAttribute;
    }
    if ((0, utils_js_1.isTimestampEnabled)(timestamps, 'modified')) {
        const modifiedName = (0, utils_js_1.getTimestampOptionValue)(timestamps, 'modified', 'name');
        const modifiedAttribute = (0, index_js_1.string)({
            required: 'atLeastOnce',
            defaults: {
                key: undefined,
                put: () => new Date().toISOString(),
                update: () => new Date().toISOString()
            }
        })
            /**
             * @debt type "when provided in options, 'hidden' is not correctly inferred"
             */
            .hidden((0, utils_js_1.getTimestampOptionValue)(timestamps, 'modified', 'hidden'))
            /**
             * @debt type "when provided in options, 'savedAs' is inferred as potentially undefined"
             */
            .savedAs((0, utils_js_1.getTimestampOptionValue)(timestamps, 'modified', 'savedAs'));
        internalAttributes[modifiedName] = modifiedAttribute;
    }
    for (const [attributeName, attribute] of Object.entries(internalAttributes)) {
        if (attributeName in schema.attributes) {
            throw new index_js_2.DynamoDBToolboxError('entity.reservedAttributeName', {
                message: `'${attributeName}' is a reserved attribute name.`,
                path: attributeName
            });
        }
        const { savedAs: attributeSavedAs } = attribute[attributeOptions_js_1.$state];
        if (attributeSavedAs !== undefined && schema.savedAttributeNames.has(attributeSavedAs)) {
            throw new index_js_2.DynamoDBToolboxError('entity.reservedAttributeSavedAs', {
                message: `'${attributeSavedAs}' is a reserved attribute alias (savedAs).`,
                path: attributeName
            });
        }
    }
    return schema.and(internalAttributes);
};
exports.addInternalAttributes = addInternalAttributes;
